<template>
  <section>
    <AprobarPermiso />
    <RechazarPermiso/>
    <VerPermisoJefe />
  
    <h3 class="primary--text">
      <v-icon info>exit_to_app</v-icon>Listado de papeletas con solicitud a cargo de vacación-Superior jerarquico 
    </h3>
    <v-card>
      <v-card-text>
        <crud-table
          :headers="headers"
          :url="url"
          :filters="filters"
          :graphql="graphql"
          :data-graphql="dataGraphql"
          :widthModal="840"
          :initData="initData"
        >
          <template slot="items" slot-scope="items">
            <td>{{ items.item.numero }}</td>
            <td>{{ items.item.nombres }}</td>
            <td>{{ items.item.fecha_emision }}</td>
            <td>{{ items.item.fecha_desde }}</td>
            <td>{{ items.item.fecha_retorno }}</td>
            <td>{{ items.item.estado_permiso }}</td>
            <td>{{ items.item.horas_permiso }}</td>
            <td v-if="!items.item.nro_dias">0</td>
            <td v-if="items.item.nro_dias">{{ items.item.nro_dias }}</td>
            <td>
              <v-btn
                color="info"
                @click.prevent="verPermisoJefe(items.item)"
                icon
                title="Ver permiso"
              >
                <v-icon>remove_red_eye</v-icon>
              </v-btn>

              <!-- btn de aprobacion -->

              <v-btn
                v-if="
                  (items.item.id_estado == 6 || items.item.id_estado == 21)"
                color="success"
                @click.prevent="aprobarPermiso(items.item)"
                icon
                title="Aprobar permiso"
              >
                <v-icon>done</v-icon>
              </v-btn>

              <v-btn
                v-if="
                  (items.item.id_estado == 6 || items.item.id_estado == 21)
                "
                color="#E61C5B"
                @click.prevent="rechazarPermiso(items.item)"
                icon
                title="Rechazar permiso"
              >
                <v-icon>close</v-icon>
              </v-btn>

              <!-- btn de aprobacion otros -->
             
            </td>
          </template>
        </crud-table>
      </v-card-text>
    </v-card>
  </section>
</template>

<script>
import CrudTable from "@/common/util/crud-table/CrudTable.vue";
import crud from "@/common/util/crud-table/mixins/crud-table";
import AprobarPermiso  from "./dialogs/AprobarPermiso";
import VerPermisoJefe from "./dialogs/VerPermisoJefe";
import RechazarPermiso from "./dialogs/RechazarPermiso";

export default {
  mixins: [crud],
  mounted() {
    this.$bus.$on("closeDialog", () => {
      this.updateList();
    });
      this.onFilter();
  },
  data() {
    return {
      graphql: true, // Definiendo el CRUD con Graphql
      url: "vPermisosJerarquicos",
      headers: [
        { text: "Nro", value: "numero", sortable: true },
        { text: "Nombres", value: "nombres", sortable: true },
        { text: "Fecha solicitud", value: "fecha_emision", sortable: true },
        { text: "Fecha salida", value: "fecha_desde", sortable: true },
        { text: "Fecha fin", value: "fecha_retorno", sortable: true },
        { text: "Estado", value: "estado_permiso", sortable: true },
        { text: "Horas", value: "horas_permiso", sortable: true },
        { text: "Días", value: "nro_dias", sortable: true },
        { text: this.$t("common.actions"), sortable: false }
      ],
      dataGraphql: `
          id
          id_permiso
          ruta_archivo
          lugar
          id_tipo_permiso
          fecha_nac_muerte
          hora_nac_muerte
          id_funcionario
          id_jefe
          nivel
          nombres
          numero
          fecha_emision
          tipo_permiso
          fecha_retorno
          estado_permiso
          nro_dias
          horas_permiso
          fecha_desde
          id_estado
          motivo
          justificacion
      `,

      filters: [
        {
          field: "numero",
          label: "Numero",
          type: "text",
          typeG: "String"
        },
        {
          field: "nombres",
          label: "Nombres",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_emision",
          label: "Fecha solicitud",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_desde",
          label: "Fecha salida",
          type: "text",
          typeG: "String"
        },
        {
          field: "fecha_retorno",
          label: "Fecha retorno",
          type: "text",
          typeG: "String"
        },
       
        {
          field: "horas_permiso",
          label: "Horas",
          type: "text",
          typeG: "String"
        },
        {
          field: "nro_dias",
          label: "Dias",
          type: "text",
          typeG: "String"
        },
        {
          field: "estado_permiso",
          label: "Estado de permiso",
          type: "text",
          typeG: "String"
        }
      ],

      initData: [
        {
          state: true,
          param: "id_jefe",
          value: this.getUserId()
        },
        {
          state: true,
          param: "id_tipo_permiso",
          value: 24
        },
      ],
      valid: true
    };
  },
  methods: {
      aprobarPermiso(item) {
        item.nivel_jefe=1
      this.$bus.$emit("openDialogAprobarPermisoCtaVacacion", item);
    },
   
    rechazarPermiso(item) {
        this.$bus.$emit("openDialogRechazarPermisoCtaVacacion", item);
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    verPermisoJefe(item) {
      this.$bus.$emit("openDialogVerPermisoJefe", item);
    },
    async verDocumento(item) {
      this.$bus.$emit("openDialogVerDocumento", item);
    }
  },
  components: {
   CrudTable,
    AprobarPermiso,
    VerPermisoJefe,
    RechazarPermiso,
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/AprobacionPapeletaVacacionJefeSuperior.vue